import React, {useEffect} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {renderRoutes} from 'react-router-config';
import {object} from 'prop-types';
import {useDispatch} from 'react-redux';
import {useHistory, useParams} from 'react-router';
import {fetchSelectedDistrict} from 'app/actions/sessionActions';
import {ErrorHandler} from 'app/components/error/ErrorHandler';

const CompetitionPage = ({route}) => {
  const {districtSlug} = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // set header on back navigation
    dispatch(fetchSelectedDistrict(districtSlug, 'Ligen und Turniere', history.location.pathname));
  }, []);

  return (
    <ErrorHandler subroute={true}>
      <ContentAdDesktop superbannerOnly bgColor noTabs top='4.5rem'>
        {renderRoutes(route.routes, {dispatchRedux: dispatch})}
      </ContentAdDesktop>
    </ErrorHandler>
  );
};

CompetitionPage.propTypes = {
  route: object.isRequired,
};

export default CompetitionPage;
